enum ApiStatus {
  Success = 200,
  Created = 201,
  Error = 500,
  SessionExpired = 401,
}

export { ApiStatus };
